import * as Sentry from '@sentry/vue';


// Attempt to capture more info about unhandled promise rejections that are not Error objects
function handleUnhandledRejection(event) {
  const reason = event.reason;
  event.preventDefault();

  if (typeof reason === 'string') {
    const error = new Error(`Unhandled promise rejection: ${reason}`);
    Sentry.captureException(error);
    //
  } else if (!(reason instanceof Error)) {
    // Not a string but not an Error object either
    const error = new Error('Unhandled promise rejection (see extra data)');

    Sentry.withScope(scope => {
      scope.setExtra('reason', reason);
      Sentry.captureException(error);
    });
    //
  } else { // Regular Error object
    Sentry.captureException(reason);
  }
}


export default function initializeSentry(vueInstance) {
  const dsnLink = document.getElementById('sentry_javascript_dsn');
  if (dsnLink) {
    Sentry.init({
      dsn: dsnLink.href,
      Vue: vueInstance,
    });
    console.log('[SENTRY] Initialized');
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    //
  } else {
    console.log('[SENTRY] Sentry loaded but disabled, DSN not provided');
  }

  // Parse advisor data if available
  const elem = document.getElementById('ADVISOR_JSON');
  const advisor = elem ? JSON.parse(elem.textContent) : null;

  // Link user to Sentry
  const user = advisor?.user;

  if (user && dsnLink) {
    Sentry.setUser({
      id: user.id,
      email: user.email,
    });
  }
}
